export interface PrefilledCredentials {
  email: string;
  nickname: string;
}

const safeDecodeURIComponent = (value: string): string => {
  try {
    return decodeURIComponent(value);
  } catch (error) {
    console.warn('Failed to decode URI component:', error);
    return value;
  }
};

const decodeBase64Email = (encodedEmail: string): string => {
  const normalized = safeDecodeURIComponent(encodedEmail)
    .replace(/-/g, '+')
    .replace(/_/g, '/')
    .replace(/\s/g, '+');

  let padded = normalized;
  const remainder = normalized.length % 4;
  if (remainder > 0) {
    padded = normalized.padEnd(normalized.length + (4 - remainder), '=');
  }

  try {
    return atob(padded).trim();
  } catch (error) {
    console.warn('Failed to decode base64 email parameter:', error);
    return '';
  }
};

export const getEmailAndNicknameFromQuery = (): PrefilledCredentials => {
  if (typeof window === 'undefined' || typeof window.location === 'undefined') {
    return { email: '', nickname: '' };
  }

  const params = new URLSearchParams(window.location.search);
  let email = params.get('em');

  if (email) {
    email = safeDecodeURIComponent(email.trim());
  } else {
    const encodedEmail = params.get('em64');
    if (encodedEmail) {
      email = decodeBase64Email(encodedEmail);
    }
  }

  if (!email) {
    return { email: '', nickname: '' };
  }

  const [nickname] = email.split('@', 1);
  return {
    email,
    nickname: nickname || '',
  };
};
